export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';



// WEBPACK FOOTER //
// ./src/store/reducers/login/actionTypes.js